import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import clsx from 'clsx'
import * as React from 'react'

import CheckSmall from '@/components-latest/primitives/Icons/CheckSmall'

import Styles from './Checkbox.module.scss'

type ICheckboxProps = React.ComponentPropsWithoutRef<
  typeof CheckboxPrimitive.Root
> & {
  variant?: 'default' | 'branded'
}

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  ICheckboxProps
>(({ className, variant = 'default', ...props }, ref) => (
  <CheckboxPrimitive.Root
    data-testid="checkbox"
    ref={ref}
    className={clsx(Styles.box, className, {
      [Styles.branded]: variant === 'branded'
    })}
    {...props}>
    <CheckboxPrimitive.Indicator>
      <CheckSmall />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName

export type { ICheckboxProps }
export default Checkbox
